var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.52795,
  y: 1.5,
  width: 14,
  height: 14,
  rx: 1,
  fill: "#1160FF",
  stroke: "#1160FF",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.5329 11.8614C7.2729 11.8614 7.0229 11.7614 6.8229 11.5714L4.8229 9.57139C4.4329 9.18139 4.4329 8.55139 4.8229 8.16139C5.2129 7.77139 5.8429 7.77139 6.2329 8.16139L7.5229 9.45139L10.8229 6.15139C11.2129 5.76139 11.8429 5.76139 12.2329 6.15139C12.6229 6.54139 12.6229 7.17139 12.2329 7.56139L8.2429 11.5714C8.0429 11.7714 7.7929 11.8614 7.5329 11.8614Z",
  fill: "white"
})));
export default SvgIconChecked;